interface VulnerabilityProps {
  name: string;
  unique_name: string;
}

export class Vulnerability implements VulnerabilityProps {
  name: string;
  unique_name: string;

  constructor(data: VulnerabilityProps) {
    this.name = data.name;
    this.unique_name = data.unique_name;
  }
}
